// extracted by mini-css-extract-plugin
export default {"container":"jn-z","bubbleNav":"kn-z","graphic":"ln-z","contact":"mn-z"};